import React from "react";

import { Placeholder } from "../page-components";

function AffiliatesPage(props) {
  return <Placeholder title="Affiliates" {...props} />;
}

export default AffiliatesPage;
